import { ChangeDetectionStrategy, Component, inject, Input } from "@angular/core";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { Tradable } from "@models/interfaces/tradable";
import { Web3Facade } from "@modules/web3/+state/web3.facade";
import { Observable } from "rxjs";
import { AsyncPipe, PercentPipe } from "@angular/common";
import { MoSuccessVisionBannerState } from "@modules/web3/components/mo-success-vision-component/mo-success-vision-banner-state.model";

@Component({
	selector: "mo-success-vision-component",
	imports: [TranslationPipeModule, AsyncPipe, PercentPipe],
	standalone: true,
	templateUrl: "./mo-success-vision-component.component.html",
	styleUrl: "./mo-success-vision-component.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MoSuccessVisionComponentComponent {
	private readonly web3Facade = inject(Web3Facade);
	@Input()
	public bannerState: MoSuccessVisionBannerState;
	@Input()
	public feeAmount: string;
	@Input()
	public isVision: boolean = false;
	public bannerStateEnum = MoSuccessVisionBannerState;

	public visionTradable$: Observable<Tradable> = this.web3Facade.getVisionTradable$();
}
